/**
 * Theme palettes from THEME-DESIGN.md §3.
 * Use getPalette('light' | 'dark') for createTheme.
 */

const lightPalette = {
  mode: 'light',
  primary: {
    main: '#00A7E3',
    light: '#4DC3F0',
    dark: '#0080B8',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#00B3A1',
    light: '#5EEAD4',
    dark: '#0D9488',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#EF4444',
    light: '#FEE2E2',
    dark: '#B91C1C',
  },
  warning: {
    main: '#F59E0B',
    light: '#FEF3C7',
    dark: '#D97706',
  },
  success: {
    main: '#10B981',
    light: '#D1FAE5',
    dark: '#059669',
  },
  info: {
    main: '#00A7E3',
    light: '#E0F7FF',
    dark: '#0080B8',
  },
  background: {
    default: '#F8FAFC',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#102E5C',
    secondary: '#64748B',
    disabled: '#94A3B8',
  },
  divider: '#E2E8F0',
  grey: {
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
  },
  action: {
    hover: 'rgba(0, 167, 227, 0.08)',
    selected: 'rgba(0, 167, 227, 0.12)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
};

const darkPalette = {
  mode: 'dark',
  primary: {
    main: '#00A7E3',
    light: '#00B8F0',
    dark: '#0080B8',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#00B3A1',
    light: '#2DD4BF',
    dark: '#0D9488',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#F87171',
    light: '#7F1D1D',
    dark: '#B91C1C',
  },
  warning: {
    main: '#FBBF24',
    light: '#78350F',
    dark: '#D97706',
  },
  success: {
    main: '#10B981',
    light: '#064E3B',
    dark: '#059669',
  },
  info: {
    main: '#00A7E3',
    light: '#0A1F3D',
    dark: '#00B8F0',
  },
  background: {
    default: '#151C28',
    paper: '#1E2A3D',
  },
  text: {
    primary: '#F1F5F9',
    secondary: '#94A3B8',
    disabled: '#64748B',
  },
  divider: '#334155',
  grey: {
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
  },
  action: {
    hover: 'rgba(255, 255, 255, 0.08)',
    selected: 'rgba(0, 167, 227, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
  },
};

export function getPalette(mode) {
  return mode === 'dark' ? darkPalette : lightPalette;
}
